import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #CHIPS
\*------------------------------------ */
/**
 * Default chip
 1) These are interactive and can be used for a single selection.
 */
:host {
  --cat-chip-border: var(--cat-theme-color-border-strong);
  --cat-chip-border-hover: var(--cat-theme-color-border-strong-hover);
  --cat-chip-border-hover-active: var(--cat-theme-color-border-strong-hover);
  --cat-chip-border-active: var(--cat-theme-color-border-strong);
  display: flex;
}

.cat-c-chip {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: var(--cat-border-radius-md);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  padding: var(--cat-dropdown-cross-icon-padding, calc(var(--size-base-unit) * 0.25) var(--cat-space-x-small));
  gap: var(--cat-space-3x-small);
  border-width: 1px;
  border-style: solid;
  color: var(--cat-chip-color, var(--cat-theme-color-content-strong));
  border-color: var(--cat-chip-border, var(--cat-theme-color-border-strong));
  background-color: var(--cat-chip-background, var(--cat-theme-color-background-default));
  vertical-align: bottom;
  margin: 0;
  max-width: var(--cat-chip-label-width, 275px);
}
@media (hover: hover) and (pointer: fine) {
  .cat-c-chip:hover:not(.cat-c-chip-is-readonly, .cat-c-chip-is-disabled) {
    color: var(--cat-chip-color-hover, var(--cat-theme-color-content-subtle-hover));
    border-color: var(--cat-chip-border-hover, var(--cat-theme-color-strong-hover));
    background-color: var(--cat-chip-background-hover, var(--cat-theme-color-background-default-hover));
  }
  .cat-c-chip:hover:not(.cat-c-chip-is-readonly, .cat-c-chip-is-disabled).cat-c-chip-is-active {
    color: var(--cat-chip-color-hover-active, var(--cat-theme-color-content-knockout-hover));
    border-color: var(--cat-chip-border-hover-active, var(--cat-theme-color-border-strong-hover));
    background-color: var(--cat-chip-background-hover-active, var(--cat-theme-color-background-xstrong-hover));
  }
}
.cat-c-chip:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  border-radius: var(--cat-border-radius-md);
}
.cat-c-chip.cat-c-chip-is-active {
  color: var(--cat-chip-color-active, var(--cat-theme-color-content-knockout));
  border-color: var(--cat-chip-border-active, var(--cat-theme-color-border-strong));
  background-color: var(--cat-chip-background-active, var(--cat-theme-color-background-xstrong));
}
.cat-c-chip ::slotted(*:not(cat-icon)) {
  margin-block-end: 0;
}
.cat-c-chip.cat-c-chip-is-disabled {
  cursor: not-allowed;
  background-color: var(--cat-theme-color-background-disabled);
  border-color: var(--cat-theme-color-border-disabled);
  color: var(--cat-theme-color-content-disabled);
}
.cat-c-chip.cat-c-chip-is-disabled .cat-c-chip__label {
  color: var(--cat-theme-color-content-subtle);
}
.cat-c-chip.cat-c-chip-removable {
  padding-inline-end: calc(var(--size-base-unit) * 4.5);
}
.cat-c-chip.cat-c-chip-is-readonly {
  --cat-icon-fill: var(--cat-theme-color-content-default);
  pointer-events: none;
  border: calc(var(--size-base-unit) * 0.125) solid var(--cat-theme-color-border-disabled);
}
.cat-c-chip.cat-c-chip-is-readonly .cat-c-chip__label {
  color: var(--cat-theme-color-content-default);
}

.cat-c-chip__item {
  list-style: none;
  display: inline-flex;
}

.cat-c-chip__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cat-c-chip__wrapper {
  position: relative;
  display: inline-flex;
}

.cat-c-chip-close__button {
  --cat-icon-height: calc(var(--size-base-unit) * 1.5);
  --cat-icon-width: calc(var(--size-base-unit) * 1.5);
  position: absolute;
  border: none;
  background: none;
  padding: var(--cat-space-3x-small);
  transform: translateY(-50%);
  inset-block-start: 50%;
  inset-inline-end: var(--cat-space-x-small);
  cursor: pointer;
}
.cat-c-chip-close__button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  border-radius: var(--cat-border-radius-md);
}
.cat-c-chip-close__button:disabled {
  cursor: not-allowed;
}

/**
 * Chip large
 1) Has more padding than the default chip.
 */
.cat-c-chip--small {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
}

.cat-c-chip--loader {
  display: flex;
  max-width: calc(var(--size-base-unit) * 12.125);
  width: 100%;
}
.cat-c-chip--loader.cat-c-chip--loader-small {
  max-width: calc(var(--size-base-unit) * 11.375);
}
.cat-c-chip--loader:not(.cat-c-chip--loader-small).cat-c-chip--loader-removable {
  max-width: calc(var(--size-base-unit) * 12.625);
}

/* Styles for chip skeleton loader */
cat-skeleton {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 0.5) calc(var(--size-base-unit) * 1);
  width: 100%;
}
.cat-c-chip--loader-small cat-skeleton {
  --cat-skeleton-loader-height: calc(var(--size-base-unit) * 0.25) calc(var(--size-base-unit) * 1);
}
cat-skeleton .cat-c-chip--loader-section {
  display: flex;
  align-items: center;
  gap: 8px;
}
cat-skeleton .cat-c-chip--loader-section .cat-c-chip--loader-body {
  background-color: var(--cat-theme-color-background-subtle-hover);
  height: 16px;
  width: 100%;
}

/* Styles for Close icon in removable chips */
cat-icon-close {
  --cat-icon-fill: var(--cat-theme-color-content-strong);
}
.cat-c-chip-close__button:disabled cat-icon-close {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
}
.cat-c-chip-close__button.cat-c-chip-close__button-readonly cat-icon-close {
  --cat-icon-fill: var(--cat-theme-color-content-default);
}
.cat-c-chip--loader cat-icon-close {
  display: none;
}
.cat-c-chip--loader-removable cat-icon-close {
  --cat-icon-fill: var(--cat-theme-color-content-default);
  --cat-icon-height: calc(var(--size-base-unit) * 1.5);
  --cat-icon-width: calc(var(--size-base-unit) * 1.5);
  display: block;
}
`;
